/* eslint-disable no-param-reassign */
import { events, routerPath } from "@/constants";
import { IMessage } from "@/services/message";
import {
  channelTypeCorrespondingText,
  ChannelTypeEnum,
  chatSdkHooks,
  globalChannelMessageWsClient,
  MailConversationDataType,
  WechatContactType,
  WechatConversationDataType,
  WecomContactType,
  WecomConversationDataType,
} from "@packages/chat-sdk";
import { eventBus } from "./eventBus";
import { history } from "@umijs/max";
import { wecomChatPersistentStore } from "@/pages/channel-chat/channel-chat-list/wecom-chat/store";
import { wechatChatPersistentStore } from "@/pages/channel-chat/channel-chat-list/wechat-chat/store";
import { whatsappChatPersistentStore } from "@/pages/channel-chat/channel-chat-list/whatsapp-chat/store";
import { nanoid } from "nanoid";
import channelActions from "./channelActions";
import { mailChatPersistentStore } from "@/pages/channel-chat/channel-chat-list/email/store";
import MailIcon from "@/assets/images/mail/other.webp";

class DamselfishNotification {
  permission = false;
  notifications: Map<string, Notification> = new Map();
  constructor() {
    this.init();
  }
  init() {
    try {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          this.permission = true;
        }
      });
    } catch {
      console.log("当前浏览器不支持Notification");
    }
  }
  open(title: string, options: NotificationOptions & { onClick?: () => void }) {
    if (this.permission) {
      const notification = new Notification(title, options);
      notification.onclick = () => {
        options.onClick?.();
      };
      this.notifications.set(options?.tag!, notification);
    }
  }
  close() {
    try {
      this.notifications.forEach((notification) => {
        notification.close();
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.notifications.clear();
    }
  }
}
const damselfishNotification = new DamselfishNotification();

chatSdkHooks.common.globalChannelMessageHook.subscribe(
  ({ channelType, conversation }) => {
    if (window.location.pathname !== routerPath.UNREAD_CONVERSATION_LIST) {
      let icon = conversation?.avatar;
      if (channelType !== ChannelTypeEnum.Email) {
        conversation = conversation as unknown as
          | WechatConversationDataType
          | WecomConversationDataType;
        if (
          conversation.chat_type === WechatContactType.ROOM ||
          conversation.chat_type === WecomContactType.OUTER_ROOM ||
          conversation.chat_type === WecomContactType.INNER_ROOM
        ) {
          icon = undefined;
        }
        if (
          conversation?.from_user_id === conversation?.last_message?.sender_id
        ) {
          return;
        }
        if (conversation?.is_shield) {
          return;
        }
        if (
          window.location.pathname ===
            routerPath.CHANNEL_CHAT_LIST_WECOM_CHAT &&
          wecomChatPersistentStore.get()?.chatId === conversation?.chat_id &&
          document?.visibilityState === "visible"
        ) {
          return;
        }

        if (
          window.location.pathname ===
            routerPath.CHANNEL_CHAT_LIST_WECHAT_CHAT &&
          wechatChatPersistentStore.get()?.fromUserId ===
            conversation?.from_user_id &&
          wechatChatPersistentStore.get()?.toUserId ===
            conversation?.another_id &&
          document?.visibilityState === "visible"
        ) {
          return;
        }

        if (
          window.location.pathname ===
            routerPath.CHANNEL_CHAT_LIST_WHATSAPP_CHAT &&
          whatsappChatPersistentStore.get()?.fromUserId ===
            conversation?.from_user_id &&
          whatsappChatPersistentStore.get()?.toUserId ===
            conversation?.another_id &&
          document?.visibilityState === "visible"
        ) {
          return;
        }
        damselfishNotification.open(
          `${channelTypeCorrespondingText[channelType]}新消息提醒`,
          {
            body: conversation?.name
              ? `“${conversation?.name}${
                  (conversation as WecomConversationDataType)?.corp_short_name
                    ? `@${
                        (conversation as WecomConversationDataType)
                          ?.corp_short_name
                      }`
                    : ""
                }”给你发送了一条新消息`
              : "收到一条新的消息",
            tag: `damselfish-${nanoid(8)}`,
            icon,
            onClick: () => {
              channelActions.selectConversation(conversation, channelType);
              damselfishNotification.close();
            },
          }
        );
        return;
      }

      if (channelType === ChannelTypeEnum.Email) {
        conversation = conversation as unknown as MailConversationDataType;
        if (
          window.location.pathname === routerPath.CHANNEL_CHAT_LIST_MAIL_CHAT &&
          mailChatPersistentStore.get().chatId === conversation?.chat_id &&
          document?.visibilityState === "visible"
        ) {
          return;
        }
        damselfishNotification.open(
          `${channelTypeCorrespondingText[channelType]}新消息提醒`,
          {
            body: conversation?.name
              ? `“${conversation?.name}”给你发送了一条新邮件`
              : "收到一条新的邮件",
            tag: `damselfish-${nanoid(8)}`,
            icon: MailIcon,
            onClick: () => {
              channelActions.selectConversation(conversation, channelType);
              damselfishNotification.close();
            },
          }
        );
        return;
      }
    }
  }
);

/**
 * 初始化通知链接
 */
export const initNotification = () => {
  globalChannelMessageWsClient.connect();

  const source = new EventSource(
    "/api/damselfish-central-backend/innerMessage/push"
  );
  source.onmessage = (ev) => {
    if (window.location.pathname !== routerPath.UNREAD_CONVERSATION_LIST) {
      try {
        const data = JSON.parse(ev.data) as IMessage;
        damselfishNotification.open(data.title, {
          body: data.content,
          tag: `damselfish-${nanoid(8)}`,
          onClick: () => {
            if (window.location.pathname !== routerPath.NOTIFICATION) {
              history.push(routerPath.NOTIFICATION);
            } else {
              window.location.reload();
            }
            damselfishNotification.close();
          },
        });
        eventBus.emit(events.notification);
      } catch {}
    }
  };

  window.electronApi?.onWindowMessage((data: any) => {
    if (window.location.pathname === routerPath.UNREAD_CONVERSATION_LIST) {
      return;
    }
    if (data?.type === "selectConversation") {
      const { channelType, conversation } = data?.payload;
      channelActions.selectConversation(conversation, channelType, false);
    } else if (data?.type === "showMoreUnreadConversation") {
      const { channelType } = data?.payload;
      if (
        window.location.pathname !== routerPath.CHANNEL_CHAT_LIST_WECOM_CHAT &&
        channelType === ChannelTypeEnum.Wecom
      ) {
        history.push({
          pathname: routerPath.CHANNEL_CHAT_LIST_WECOM_CHAT,
        });
      } else if (
        window.location.pathname !== routerPath.CHANNEL_CHAT_LIST_WECHAT_CHAT &&
        channelType === ChannelTypeEnum.Wechat
      ) {
        history.push({
          pathname: routerPath.CHANNEL_CHAT_LIST_WECHAT_CHAT,
        });
      } else if (
        window.location.pathname !== routerPath.CHANNEL_CHAT_LIST_MAIL_CHAT &&
        channelType === ChannelTypeEnum.Email
      ) {
        history.push({
          pathname: routerPath.CHANNEL_CHAT_LIST_MAIL_CHAT,
        });
      } else if (
        window.location.pathname !==
          routerPath.CHANNEL_CHAT_LIST_WHATSAPP_CHAT &&
        channelType === ChannelTypeEnum.WhatsApp
      ) {
        history.push({
          pathname: routerPath.CHANNEL_CHAT_LIST_WHATSAPP_CHAT,
        });
      }
    }
  });
};
